<vcl-modal
  id="termsModal"
  [modalTitle]="terms.title"
  *ngIf="terms"
  [(showModal)]="showModal"
  [buttonLabels]="buttonLabelsModal"
  (modalButtonClick)="modalAction($event)"
>
  <p id="pdfText" [innerHtml]="terms.text" *ngIf="showSecondaryButton"></p>
</vcl-modal>

<div class="principality-credit-card">
  <h2 class="title">
    {{
      copyService.getParametrizedCopy(copiesProperty['mainLabel'], [
        documentInfo.firstname
      ])
    }}
    <strong>{{
      copyService.copies.principality_credit_card_title_saving_basic1
    }}</strong>
  </h2>
  <br />
  <div class="subtitle">
    <strong>{{ copyService.copies.principality_credit_card_title }}</strong>
  </div>
  <ul>
    <vcl-list
      class="basic"
      *ngIf="
        selectedProduct.product_type === 'creditCard' &&
        (this.infoInferredIncomes.account_type === '211' ||
          this.infoInferredIncomes.account_type === '218' ||
          this.infoInferredIncomes.account_type === '232')
      "
    >
      <li *ngFor="let detail of transactionkit.detail" vclListSimple>
        <vcl-list-text>
          <div class="list-basic">
            <span *ngIf="detail.icon" class="{{ detail.icon }}"> </span>
            <span *ngIf="detail.icon" class="tittle">{{ detail.title }}</span>
            <br />
            <span *ngIf="detail.detail1" class="{{ detail.detail1.class }}">{{
              detail.detail1.text
            }}</span>
          </div>
        </vcl-list-text>
      </li>
    </vcl-list>
  </ul>
  <br />
  <span class="notes">{{
    copyService.copies.principality_credit_card_note
  }}</span>
  <div class="terms">
    <div class="link">
      <vcl-link
        [linkId]="'termsid'"
        (click)="toggleModal()"
        [label]="copyService.copies[copiesProperty['termsLabel']]"
      >
      </vcl-link>

      <span class="icon icon-itaufonts_seta_right"></span>
    </div>
    <br />
    <voxel-checkbox
      [id]="'checkboxTermsId'"
      [label]="checkboxTerms.label"
      [checked]="checkboxTerms.checked"
      name="terms"
      [value]="checkboxTerms.value"
      (checkboxChange)="checkboxChange($event)"
    ></voxel-checkbox>
  </div>
  <br />

  <app-controls
    id="detailAccountCreationBtns"
    [hasPrevious]="true"
    [nextLabel]="copyService.copies.principality_credit_card_button"
    [nextDisabled]="isBtnDisabled"
    (next)="onNext()"
    [previousLabel]="copyService.copies.principality_credit_card_button_previous"
    (previous)="onPrevious()"
  ></app-controls>
</div>
